import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { tap, retry } from "rxjs/operators";
import { throwError, timer, Observable } from "rxjs";

@Injectable()
export class URLInterceptor implements HttpInterceptor {
  private readonly MAX_RETRIES = 3;
  private readonly RETRY_DELAY_MS = 1000;

  constructor(private router: Router) {}

  private retryWith504Handling() {
    return retry<HttpEvent<any>>({
      count: this.MAX_RETRIES,
      delay: (error: HttpErrorResponse, retryCount: number) => {
        if (error.status === 504) {
          const delayMs = this.RETRY_DELAY_MS * Math.pow(2, retryCount - 1);
          return timer(delayMs);
        }
        return throwError(() => error);
      },
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      "/demo1/scoreAndVerstat" === this.router.url
    || "/demo1/categoryReport" === this.router.url
    || "/demo1/scoreDistribution" === this.router.url
    || "/demo1/providerInsights" === this.router.url
    || "/demo1/industryHighRunners" === this.router.url) {
      var newReq = null;
      if(req.url === 'si/service/file/getOrigidFileNames'){
        newReq = req.clone({
          params: req.params.append("carrier", "Cox"),
          setParams: {
            carrier: "Frontier",
            termination_carrier: "Frontier",
            timeFrameFilter: "day",
            filter_type: "inbound"

          },
          setHeaders: {
            orgname: "Frontier",
          },
        });
      } else {
        newReq = req.clone({
        params: req.params.append("carrier", "Cox"),
        setHeaders: {
          orgname: "Cox",
        },
      });
    }
      return next.handle(newReq).pipe(
        this.retryWith504Handling(),
        // proceed when there is a response; ignore other events
        tap((event) => {
          if (event instanceof HttpResponse) {
            if (event.url && event.url.indexOf("getPointCodeVolume") != -1) {
            }
            return event;
          }
        })
      );
    } else if (
      "/demo2/scoreAndStirorShaken" === this.router.url
    || "/demo2/byCategory" === this.router.url) {
      const newReq = req.clone({
        params: req.params.append("carrier", "Sinch"),
        setHeaders: {
          orgname: "Sinch",
        },
      });
      return next.handle(newReq).pipe(
        this.retryWith504Handling(),
        // proceed when there is a response; ignore other events
        tap((event) => {
          if (event instanceof HttpResponse) {
            if (event.url && event.url.indexOf("getPointCodeVolume") != -1) {
            }
            return event;
          }
        })
      );
    } 
    else if (
      "/demo/scoreAndStirorShakenByClient" === this.router.url) {
      const newReq = req.clone({
        params: req.params.append("tabName", "robocall"),
      });
      return next.handle(newReq).pipe(
        this.retryWith504Handling(),
        // proceed when there is a response; ignore other events
        tap((event) => {
          if (event instanceof HttpResponse) {
            if (event.url && event.url.indexOf("getPointCodeVolume") != -1) {
            }
            return event;
          }
        })
      );
    } else if (
      "/demo/providerInsights" === this.router.url ||
      "/demo/industryHighRunners" === this.router.url ||
      "/demo/scoreDistribution" === this.router.url ||
      "/demo/robocallScoring" === this.router.url
    ) {
      const modifiedReq = req.clone({
        params: req.params.append("tabName", "robocall"),
        setParams: {
          carrier: "Frontier",
          termination_carrier: "Frontier",
        },
        setHeaders: {
          orgname: "Frontier",
        },
      });
      return next.handle(modifiedReq).pipe(
        this.retryWith504Handling()
      );
    } else if (
      "/whlc/robocallScoring" === this.router.url || 
      "/whlc/industryHighRunners" === this.router.url ||
      '/whlc/scoreAndStirorShaken' === this.router.url
    ) {
      var newReq = null;
      newReq = req.clone({
        params: req.params.set("carrier", "whitelabelcommunications"),
        setHeaders: {
          orgname: "whitelabelcommunications",
        },
      });
      return next.handle(newReq).pipe(
        this.retryWith504Handling()
      );
    } 
    return next.handle(req).pipe(
      this.retryWith504Handling()
    );
  }
}
